import React, { useEffect, useMemo, useState } from 'react';

import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import helpers from 'app/utils/helpers';

function CompanyInfo(props) {
  const { classes } = props;

  const activeCompany = useSelector(state => state.company.activeCompany);
  const user = useSelector(state => state.auth.user);
  const registrationUserInfo = useSelector(state => state.auth.registrationInfo);
  const userAdmin = useSelector(state => state.auth.userAdmin);
  const request = useSelector(state => state.requests.details);
  const internalNewRequest = useSelector(state => state.forms.internalNewRequest);

  const [nmCompany, setNmCompany] = useState('');
  const [deCpfCnpj, setDeCpfCnpj] = useState('');

  const companyData = useMemo(() => {
    if (!request.cdSolicitacao) {
      if(internalNewRequest && internalNewRequest.company){
        return internalNewRequest.company;
      }
      if (activeCompany && Object.keys(activeCompany).length > 0) {
        return activeCompany;
      } else if (user.cdUsuarioAdmin) {
        return userAdmin;
      } else if (registrationUserInfo && Object.keys(registrationUserInfo).length > 0) {
        return registrationUserInfo;
      }
    } else {
      const json = JSON.parse(request.jsonSolicitacao);
      return json;
    }
    return {};
  }, [activeCompany, registrationUserInfo, request, user, userAdmin, internalNewRequest]);

  useEffect(() => {
    if (Object.keys(companyData).length > 0) {
      const name = companyData.deRazaoSocial || companyData.nmCompleto || companyData.nmUsuario;
      const doc = companyData.deCnpjMatriz || companyData.deCpf || companyData.deCpfCnpj;
      if (doc) {
        setDeCpfCnpj(helpers.formatarDocumento(doc));
      }
      if (name) {
        setNmCompany(name);
      }
    }
  }, [companyData]);

  return (
    <>
      <Grid item xs={12}>
        <h3 className={classes.title}>
          <b>Empresa/Solicitante:</b> {nmCompany}
        </h3>
        <h3 className={classes.title} style={{ marginTop: '0' }}>
          <b>CNPJ/CPF:</b> {deCpfCnpj}
        </h3>
      </Grid>
    </>
  );
}

export default CompanyInfo;
